import { createActions, createState, createReducer } from 'reduxsauce-crud'
import R, { clone } from 'ramda'
import moment from 'moment'

const d = { deep: true }
const DEEP = { deep: true }

export const ReservationRedux = createActions(
  {
    postReservationRequest: ['studentId','data'],
    postReservationSuccess: ['data'],
    postReservationError: ['err'],
    updateReservationRequest: ['id','data'],
    updateReservationSuccess: ['data','id'],
    updateReservationError: ['err'],
    deleteReservationRequest: ['id'],
    deleteReservationSuccess:['id'],
    deleteReservationFaile:['error'],
  },
  {
    prefix: 'PARENT_PLATFORM_RESERVATION_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = ReservationRedux
export const ReservationTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  postReservation: {
    fetching: false,
    error: null,
  },
  deleting: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const postReservationRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const postReservationSuccess = (state, { data }) => {
  let reservations = R.clone(state.get.results)
  if(data.length > 1){
    data.map(d =>{
      reservations.push(d)
    })
  }else{

    reservations.push(data[0])
  }

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:reservations
    }
  }, d)
}
const postReservationError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
const updateReservationRequest = state => state.merge({
  postReservation: {
    fetching: true,
    error: null,
  },
}, d)
const updateReservationSuccess = (state, { data, id }) => {
  let reservations = R.clone(state.get.results)
  const index =  R.findIndex(R.propEq('id', id))(reservations)

  if (index > -1){
    reservations.splice(index,1)
  }

  if(Array.isArray(data)){
    data.map(r =>{
      reservations.push(r)
    })
  }
  else{
    reservations.push(data)
  }

  return state.merge({
    postReservation: {
      fetching: false,
      error: null,
    },
    get: {
      results:reservations
    }
  }, d)
}
const updateReservationError = (state, { err }) => state.merge({
  postReservation: {
    fetching: false,
    error: err,
  },
}, d)
const  deleteReservationRequest = state => state.merge({
  deleting: {
    fetching: true,
    error: null,
  },
}, DEEP)
const  deleteReservationSuccess = (state,{ id }) => {
  let reservations = R.clone(state.get.results)
  const index =  R.findIndex(R.propEq('id', id))(reservations)
  if (index > -1){
    reservations.splice(index,1)
  }

  return state.merge({
    deleting: {
      fetching: false,
      error: null,
    },
    get: {
      results:reservations
    }
  }, DEEP)
}
const  deleteReservationFaile = (state,{ error }) => ( state.merge({ deleting: { fetching: false, error }}, DEEP))

export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.postReservationRequest]: postReservationRequest,
    [Types.postReservationSuccess]: postReservationSuccess,
    [Types.postReservationError]: postReservationError,
    [Types.updateReservationRequest]: updateReservationRequest,
    [Types.updateReservationSuccess]: updateReservationSuccess,
    [Types.updateReservationError]: updateReservationError,
    [Types.deleteReservationRequest]: deleteReservationRequest,
    [Types.deleteReservationSuccess]: deleteReservationSuccess,
    [Types.deleteReservationFaile]: deleteReservationFaile,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  }
)



// WEBPACK FOOTER //
// ./src/Data/Redux/ParentPlatform/ReservationRedux.js